import { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { MAX_GUESTS, SearchContext } from "components/store/source";
import {
  decrementGuests,
  incrementGuests,
  setHighlightListings,
} from "components/store/source/actions/searchCriteriaActions";

import { IconGroup } from "icons";

import Counter from "../../atoms/Counter";
import Text from "../../atoms/Text";

import styles from "./GuestCounterInline.module.scss";

export default function GuestCounterInline({
  size,
  noIcon,
  darkBorder,
  apolloTheme,
}) {
  const {
    criteria: {
      guests: { guests },
    },
    dispatch,
  } = useContext(SearchContext);

  const updateCount = actionCreator => () => {
    dispatch(actionCreator());
    dispatch(setHighlightListings(false));
  };

  const counterClasses = classnames(
    styles.guest_counter,
    styles[size],
    darkBorder && styles.dark_border,
    apolloTheme && styles.apolloTheme,
  );

  return (
    <div className={counterClasses}>
      <div className={styles.label}>
        {!noIcon && <IconGroup />}
        <Text
          translateKey="filters.guestFilter.label"
          types={[apolloTheme ? "md" : "sm"]}
        />
      </div>
      <Counter
        ariaLabelDecrement="Decrement guest counter"
        ariaLabelIncrement="Increment guest counter"
        count={guests}
        onDecrement={updateCount(decrementGuests)}
        onIncrement={updateCount(incrementGuests)}
        max={MAX_GUESTS}
        size={size}
      />
    </div>
  );
}

GuestCounterInline.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  noIcon: PropTypes.bool,
  darkBorder: PropTypes.bool,
  apolloTheme: PropTypes.bool,
};

GuestCounterInline.defaultProps = {
  size: "",
  noIcon: false,
  darkBorder: false,
};
